import { Flex } from '@chakra-ui/react';

import { LectureSearchSection } from '@/components/ui/features/schedule/ScheduleQuerySearch/IndexSections/LectureSearchSection';
import { ProfileSearchSection } from '@/components/ui/features/schedule/ScheduleQuerySearch/IndexSections/ProfileSearchSection';
import { SessionSearchSection } from '@/components/ui/features/schedule/ScheduleQuerySearch/IndexSections/SessionSearchSection';

export const SearchIndexQuery = () => {
  return (
    <Flex flexDir="column">
      <SessionSearchSection />
      <LectureSearchSection />
      <ProfileSearchSection />
    </Flex>
  );
};
